function getCssVariableValue(value) {
  var _exec;
  if (!value.startsWith('var')) {
    return value;
  }
  var variable = (_exec = /var\(([^,)]*)(,.*)?\)/.exec(value)) === null || _exec === void 0 ? void 0 : _exec[1];
  var propertyValue = variable && getComputedStyle(document.body).getPropertyValue(variable);
  return (propertyValue || "MISSING CSS VARIABLE - PLEASE FIX !!").trim();
}
export default getCssVariableValue;